export type Environment = "development" | "sandbox" | "staging" | "production";

const environments: Environment[] = [
  "development",
  "sandbox",
  "staging",
  "production",
];

const getEnvironment = (): Environment => {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT;

  if (env && environments.includes(env as Environment)) {
    return env as Environment;
  }

  return "development";
};

export const environment: Environment = getEnvironment();
